import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AppointmentPeriod } from '../models/AppointmentPeriod';

@Injectable({
  providedIn: 'root'
})
export class AppointmentPeriodService {
  private apiBaseUrl = environment.apiBaseUrl;

  private static handleError(error: Response | any): Observable<any> {
    console.error('ApiService::handleError', error);
    return throwError(error);
  }

  constructor(private http: HttpClient) {}

  getAppointmentPeriodByDates(
    availability: any
  ): Observable<Array<AppointmentPeriod>> {
    const url = `${this.apiBaseUrl}/appointmentperiod/dates`;
    return this.http
      .post<any>(url, availability)
      .pipe(catchError(AppointmentPeriodService.handleError));
  }

  saveAppointmentPeriod(appointmentPeriod: any): Observable<AppointmentPeriod> {
    const url = `${this.apiBaseUrl}/appointmentperiod`;
    return this.http
      .post<AppointmentPeriod>(url, appointmentPeriod)
      .pipe(catchError(AppointmentPeriodService.handleError));
  }

  saveAppointmentPeriods(appointmentPeriods: Array<any>): Observable<Array<AppointmentPeriod>> {
    const url = `${this.apiBaseUrl}/appointmentperiods`;
    return this.http
      .post<Array<AppointmentPeriod>>(url, appointmentPeriods)
      .pipe(catchError(AppointmentPeriodService.handleError));
  }

  deleteAppointmentPeriod(id: string): Observable<void> {
    const url = `${this.apiBaseUrl}/appointmentperiod/${id}`;
    return this.http
      .delete<void>(url)
      .pipe(catchError(AppointmentPeriodService.handleError));
  }
}
